import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <style />
    <path
      d="M7.5 1v4h5v2h-5v4h5v2h-5v4h5v2h-5v4c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1z"
      fill={ fill }
      id="prefix__Layer_1"
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
